// extracted by mini-css-extract-plugin
export default {"emptyStateDivBox":"emptyStateDivBox__6XkVO","emptyDiv":"emptyDiv__Jaf5s"};